import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { SharedModule } from "../shared.module";
import { InvoiceViewComponent } from "./invoice-view/invoice-view.component";
import { CommonModule, DatePipe } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [InvoiceViewComponent],
    imports: [SharedModule, MatDialogModule, DatePipe, MatTooltipModule, FormsModule, CommonModule, MatDialogModule],
    exports: [InvoiceViewComponent],
    providers: [],
})

export class ISInvoiceProcessorModule {}